import React, { useRef, useState } from "react";
import { Button, message } from "antd";

interface CommentInputProps {
  userAvatar: string;
  onSend: (val: string) => void;
  placeholder?: string;
  pageType: string;
}

const CommentInput: React.FC<CommentInputProps> = ({
  userAvatar,
  onSend,
  placeholder = "快來發表你的看法吧",
  pageType,
}) => {
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const [loading, setLoading] = useState(false); // 控制发布按钮状态


  const handleSend = async () => {
    const content = textareaRef.current?.value.trim() || "";

    if (!content) {
      message.info("評論內容不能為空");
      return;
    }

    if (loading) return; // 防止重复点击
    setLoading(true);

    try {
      onSend(content);
      if (textareaRef.current) {
        textareaRef.current.value = "";
      }
    } catch (err) {
      console.error(err);
      message.error("發佈失敗，請稍後再試");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center">

      {pageType !== "article" && <img src={userAvatar} className="w-50 h-50 rounded-full mr-20 mb-14" />}

      {/* 留言输入框 */}
      <div className={`flex items-center w-full gap-x-20 rounded-8 p-10 ${pageType === "article" ? "bg-[#fff]" : "bg-[#F5F5F5]"}`}>
        <div className={`flex-1`}>
          <textarea
            className={`rounded-8 w-full leading-20 text-16 text-[#000] resize-none py-6 px-10 ${pageType === "article" ? "bg-[#fff] border-1 border-[#d5d5d5] border-solid h-[80px]" : "bg-[#F5F5F5] border-none h-[100px]"}`}
            ref={textareaRef}
            placeholder={placeholder}
          />
        </div>
        <button
          className={`rounded-8 text-16 text-[#fff]  ${pageType === "article" ? "h-80 w-84 bg-[#e04739]" : "h-40 w-110 bg-[#F45749] "}`}
          onClick={handleSend}
        >
          {loading ? "發佈中..." : "發佈"}
        </button>
      </div>
    </div>
  );
};

export default CommentInput;
